export default __webpack_public_path__ + "static/media/Air_cargo.39395c4e.png";